var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIconEnd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1429 22.4286C17.8235 22.4286 22.4286 17.8235 22.4286 12.1429C22.4286 6.46225 17.8235 1.85718 12.1429 1.85718C6.46222 1.85718 1.85715 6.46225 1.85715 12.1429C1.85715 17.8235 6.46222 22.4286 12.1429 22.4286Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4114 19.4119L24.1429 24.1433",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91359 12.7051C6.28306 12.5954 6.28306 11.6902 6.91359 11.5805C9.19789 11.1831 11.0147 9.44322 11.5105 7.17825L11.5485 7.00463C11.685 6.38147 12.5723 6.37758 12.7141 6.99954L12.7603 7.20186C13.2744 9.45614 15.0918 11.1813 17.3697 11.5777C18.0035 11.6879 18.0035 12.5977 17.3697 12.7079C15.0918 13.1042 13.2744 14.8294 12.7603 17.0837L12.7141 17.286C12.5723 17.908 11.685 17.9041 11.5485 17.2809L11.5105 17.1073C11.0147 14.8424 9.19789 13.1025 6.91359 12.7051Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconEnd);
export default __webpack_public_path__ + "static/media/search-icon-end.e13b4bdc33cce6f74205413e6f43a245.svg";
export { ForwardRef as ReactComponent };